import Vue from 'vue'

const API_URL = '/api/truckers';

export default {
    namespaced: true,

    state: {
        truckers: [],
        pagination: {}
    },

    mutations: {
        ADD_TRUCKER(state, trucker) {
            state.truckers.push(trucker)
        },
        ALL_TRUCKER(state, trucker) {
            state.truckers = trucker
        },
        UPDATE_TRUCKER(state, trucker) {
            var truckers = [...state.truckers]
            var index = truckers.findIndex(x => x.id === trucker.id)
            if(index !== -1) {
                truckers[index] = trucker
                state.truckers = truckers
            }
        },
        DELETE_TRUCKER(state, id) {
            state.truckers = state.truckers.filter((x) => x.id !== id)
        },
        SET_PAGINATION(state, pagination) {
            state.pagination = pagination
        }
    },

    actions: {
        // 
        async add_trucker({commit}, form_data) {
            const resp = await Vue.prototype.$http.post(API_URL + '/add-trucker', form_data)
            commit('ADD_TRUCKER', resp.data)
            return resp
        },
        // 
        async add_registration({commit}, form_data) {
            const resp = await Vue.prototype.$http.post(API_URL + '/add-registration', form_data)
            commit('UPDATE_TRUCKER', resp.data)
            return resp
        },
        // 
        async get_truckers({commit}, page_data) {
            const resp = await Vue.prototype.$http.get(API_URL + '/get-truckers?pagination=' + page_data.pagination + '&page=' + page_data.page_num + '&sort=' + page_data.currentSort + '&dir=' + page_data.currentSortDir )
            commit('ALL_TRUCKER', resp.data.truckers.data)
            let total = resp.data.truckers.total
            let per_page = resp.data.truckers.per_page

            const pagination = {
                pages: Math.ceil(total/per_page),
                current_page: resp.data.truckers.current_page,
                last_page: resp.data.truckers.last_page,
                on_click: 'click_handler',
                total: total
            }

            commit('SET_PAGINATION', pagination)
            return resp
        },
        async get_trucker({commit}, id) {
            const resp = await Vue.prototype.$http.get(API_URL + '/get-trucker/' + id)
            commit('GET_TRUCKER', id)
            return resp
        },
        // 
        async search_trucker({commit}, form_data) {
            const resp = await Vue.prototype.$http.post(API_URL + '/search-trucker?pagination=' + form_data.pagination + '&page=' + form_data.page_num, form_data)
            commit('ALL_TRUCKER', resp.data.truckers.data)

            let total = resp.data.truckers.total
            let per_page = resp.data.truckers.per_page

            const pagination = {
                pages: Math.ceil(total/per_page),
                current_page: resp.data.truckers.current_page,
                last_page: resp.data.truckers.last_page,
                on_click: 'click_handler',
                total: total
            }

            commit('SET_PAGINATION', pagination)
            return resp
        },
        // 
        async update_trucker({commit}, form_data) {
            const resp = await Vue.prototype.$http.post(API_URL + '/update-trucker', form_data)
            commit('UPDATE_TRUCKER', resp.data)

            return resp
        },
        // 
        async delete_trucker({commit}, id) {
            const resp = await Vue.prototype.$http.delete(API_URL + '/delete-trucker/' + id)
            commit('DELETE_TRUCKER', id)
            return resp
        }
    },

    getters: {
        allTruckers: (state) => state.truckers,
        getPagination: (state) => state.pagination
    },
}